import React, { Component } from 'react'
import { Menu as MenuAntd, Icon } from 'antd';
import { NavLink, withRouter } from 'react-router-dom';
import HasAccess from '../../util/HasAccess';
import roles from '../../util/strings/roles';
const { SubMenu } = MenuAntd;

class Menu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            catalogo_seleccionado: undefined
        }
        this.toggle = props.toggle;
    }

    /**
     * Función que se ejecuta cuando se da clic en el menú
     * @param: e. valor del menú seleccionado
     * @return: nada.
     */
    handleClick = (e) => {
        let state = { ...this.state };
        state.catalogo_seleccionado = e.key;
        this.setState(state);

        // Si la resolución es <= 800px, el menú se esconde al seleccionar
        // una sección
        const width = window.innerWidth;
        if (width <= 800) {
            this.toggle();
        }
    }

    /**
     * Función que se ejecuta cuando se cierra sesión
     */
    logout = () => {
        window.location.replace("/inicio")
        localStorage.clear()
    }

    render() {
        let state = { ...this.state }
        let url = this.props.location.pathname; // Obtener la URL del sitio
        if (url === '/inicio') {
            state.catalogo_seleccionado = "1";

        } else if (url === '/articulos') {
            state.catalogo_seleccionado = "2";
        } else if (
            url === '/modelo_pedido' ||
            url === '/modelo/drive' ||
            url === '/modelo/upa' ||
            url === '/modelo/auxiliares'
        ) {
            state.catalogo_seleccionado = "3";
        } else if (url === '/productos') {
            state.catalogo_seleccionado = "4";
        } else if (url === '/equivalencia_articulos') {
            state.catalogo_seleccionado = "12";
        } else if (
            url === '/productos_drive' ||
            url === '/productos_upa' ||
            url === '/productos_auxiliares'
        ) {
            state.catalogo_seleccionado = "4";
        } else if (url === '/categorias') {
            state.catalogo_seleccionado = "5";
        } else if (url === '/calendario_pedidos') {
            state.catalogo_seleccionado = "6";
        } else if (url === '/fuente_demanda') {
            state.catalogo_seleccionado = "7";
        } else if (url === '/usuarios') {
            state.catalogo_seleccionado = "8";
        } else if (
            url === '/generar_pedido' ||
            url === '/generar/pedido'
        ) {
            state.catalogo_seleccionado = "9";
        } else if (url === '/pedidos_realizados') {
            state.catalogo_seleccionado = "10";
        } else if (url === '/reporte_asertividad') {
            state.catalogo_seleccionado = "11";
        } else if (url === '/minimos_estandares') {
            state.catalogo_seleccionado = "13";
        } else if (url === '/sustitucion_demanda') {
            state.catalogo_seleccionado = "14";
        } else if (url === '/fuente_demanda_auxiliares') {
            state.catalogo_seleccionado = "19";
        } else if (url === '/equivalencia_articulos_aux') {
            state.catalogo_seleccionado = "17";
        } else if (url === '/articulos_auxiliares') {
            state.catalogo_seleccionado = "18";
        } else if (url === '/modelo_pedido_aux') {
            state.catalogo_seleccionado = "20";
        } else if (url === '/maximo_pedidos') {
            state.catalogo_seleccionado = "21";
        } else if (url === '/generar_pedido_auxiliar') {
            state.catalogo_seleccionado = "22";
        } else if (url === '/pedidos_realizados_aux') {
            state.catalogo_seleccionado = "23";
        } else if (url === '/segmento_pv') {
            state.catalogo_seleccionado = "15";
        }
        else if (url === '/pedidos_auxiliares') {
            state.catalogo_seleccionado = "24";
        }else if (url === '/notificaciones') {
            state.catalogo_seleccionado = "16";
        }
        else if (url === '/asignar_centro') {
            state.catalogo_seleccionado = "26";
        }
        else if (url === '/asignar_unidad') {
            state.catalogo_seleccionado = "27";
        }
        else {
            // Caso por default
            state.catalogo_seleccionado = "1";
        }

        return (
            <MenuAntd mode="inline" theme='light' onClick={this.handleClick}
                selectedKeys={
                    [state.catalogo_seleccionado ?
                        state.catalogo_seleccionado : undefined]
                }
                defaultOpenKeys={['sub1', 'sub2', 'sub3', 'sub4', 'sub5', 'sub6']}
            >

                <MenuAntd.Item key="1" id="menu-inicio">
                    <Icon type="home" /><span>Inicio</span>
                    <NavLink to="/inicio"></NavLink>
                </MenuAntd.Item>

                {(localStorage.getItem("role") !== "Drive" && localStorage.getItem("role") !== "Barista" && localStorage.getItem("role") !== "Asesor" && localStorage.getItem("role") !== "Auditor")  &&
                    <SubMenu key="sub1" title={
                        <span>
                            <Icon type="switcher" />
                            <span style={{ fontSize: "18px", fontWeight: 700 }}>Catálogos</span>
                        </span>
                    }>
                        {(localStorage.getItem("role") !== "Drive") &&
                            <MenuAntd.Item key="2" id="menu-articulos">
                                <HasAccess roles={[roles.SUPERADMIN, roles.COORD, roles.SUPERVISOR, roles.ADMINISTRADOR]}>
                                    <Icon type="tags" /><span>Artículos</span>
                                    <NavLink to="/articulos"></NavLink>
                                </HasAccess>
                            </MenuAntd.Item>
                        }
                        {(localStorage.getItem("role") === "Administrador" || localStorage.getItem("role") === "SuperAdmin") &&
                            <MenuAntd.Item key="5" id="menu-categorias">
                                <HasAccess roles={[roles.SUPERADMIN, roles.ADMINISTRADOR]}>
                                    <Icon type="folder" /><span>Categorias</span>
                                    <NavLink to="/categorias"></NavLink>
                                </HasAccess>
                            </MenuAntd.Item>
                        }
                        {(localStorage.getItem("role") === "Administrador" || localStorage.getItem("role") === "SuperAdmin") &&
                            <MenuAntd.Item key="15" id="menu-sustitucion">
                                <HasAccess roles={[roles.SUPERADMIN, roles.ADMINISTRADOR]}>
                                    <Icon type="user" /><span>Segmento punto de venta</span>
                                    <NavLink to="/segmento_pv"></NavLink>
                                </HasAccess>
                            </MenuAntd.Item>
                        }
                    </SubMenu>
                }

                {(localStorage.getItem("role") !== "Drive" && localStorage.getItem("role") !== "Barista" && localStorage.getItem("role") !== "Asesor" && localStorage.getItem("role") !== "Auditor") &&
                    <SubMenu key="sub2" title={
                        <span>
                            <Icon type="code" />
                            <span style={{ fontSize: "18px", fontWeight: 700 }}>Administración</span>
                        </span>
                    }>
                        {(localStorage.getItem("role") !== "Drive" && localStorage.getItem("role") !== "Barista") &&
                            <MenuAntd.Item key="8" id="menu-usuarios">
                                <HasAccess roles={[roles.SUPERADMIN, roles.COORD, roles.SUPERVISOR, roles.ADMINISTRADOR]}>
                                    <Icon type="user" /><span>Usuarios</span>
                                    <NavLink to="/usuarios"></NavLink>
                                </HasAccess>
                            </MenuAntd.Item>
                        }
                        {(["Administrador", "Coordinador de Operaciones Drive", "SuperAdmin"].includes(localStorage.getItem("role"))) &&
                            <MenuAntd.Item key="3" id="menu-modelo-pedido">
                                <HasAccess roles={[roles.SUPERADMIN, roles.COORD, roles.ADMINISTRADOR]}>
                                    <Icon type="layout" /><span>Modelo de pedido</span>
                                    <NavLink to="/modelo_pedido"></NavLink>
                                </HasAccess>
                            </MenuAntd.Item>
                        }
                        {(localStorage.getItem("role") !== "Drive") &&
                            <MenuAntd.Item key="4" id="menu-productos">
                                <HasAccess roles={[roles.SUPERADMIN, roles.COORD, roles.SUPERVISOR, roles.ADMINISTRADOR]}>
                                    <Icon type="unordered-list" /><span>Productos</span>
                                    <NavLink to="/productos"></NavLink>
                                </HasAccess>
                            </MenuAntd.Item>
                        }
                        {(["Administrador", "SuperAdmin"].includes(localStorage.getItem("role"))) &&
                            <MenuAntd.Item key="12" id="menu-equivalencia">
                                <HasAccess roles={[roles.SUPERADMIN, roles.ADMINISTRADOR]}>
                                    <Icon type="ordered-list" /><span>Equivalencia de artículos</span>
                                    <NavLink to="/equivalencia_articulos"></NavLink>
                                </HasAccess>
                            </MenuAntd.Item>
                        }
                        {(["Administrador", "SuperAdmin"].includes(localStorage.getItem("role"))) &&
                            <MenuAntd.Item key="14" id="menu-sustitucion">
                                <HasAccess roles={[roles.SUPERADMIN, roles.ADMINISTRADOR]}>
                                    <Icon type="unordered-list" /><span>Sustitución de demanda</span>
                                    <NavLink to="/sustitucion_demanda"></NavLink>
                                </HasAccess>
                            </MenuAntd.Item>
                        }
                        {(["Administrador", "SuperAdmin"].includes(localStorage.getItem("role"))) &&
                            <MenuAntd.Item key="13" id="menu-minimos-estandares">
                                <HasAccess roles={[roles.SUPERADMIN, roles.ADMINISTRADOR]}>
                                    <Icon type="ordered-list" /><span>Mínimos estándares</span>
                                    <NavLink to="/minimos_estandares"></NavLink>
                                </HasAccess>
                            </MenuAntd.Item>
                        }
                        {(localStorage.getItem("role") !== "Drive") &&
                            <MenuAntd.Item key="6" id="menu-calendario">
                                <HasAccess roles={[roles.SUPERADMIN, roles.COORD, roles.SUPERVISOR, roles.ADMINISTRADOR]}>
                                    <Icon type="calendar" /><span>Calendario pedidos</span>
                                    <NavLink to="/calendario_pedidos"></NavLink>
                                </HasAccess>
                            </MenuAntd.Item>
                        }
                        {(["Administrador", "SuperAdmin", "Coordinador de Operaciones Drive"].includes(localStorage.getItem("role"))) &&
                            <MenuAntd.Item key="7" id="menu-fuente-demanda">
                                <HasAccess roles={[roles.SUPERADMIN, roles.COORD, roles.ADMINISTRADOR]}>
                                    <Icon type="book" /><span>Fuente de demanda</span>
                                    <NavLink to="/fuente_demanda"></NavLink>
                                </HasAccess>
                            </MenuAntd.Item>
                        }
                        {(["Administrador", "SuperAdmin"].includes(localStorage.getItem("role"))) &&
                            <MenuAntd.Item key="16" id="menu-notificaciones">
                                <HasAccess roles={[roles.SUPERADMIN, roles.ADMINISTRADOR]}>
                                    <Icon type="mail" /><span>Notificaciones</span>
                                    <NavLink to="/notificaciones"></NavLink>
                                </HasAccess>
                            </MenuAntd.Item>
                        }
                        {(["Administrador", "SuperAdmin"].includes(localStorage.getItem("role"))) &&

                            <MenuAntd.Item key="26" id="menu-asignar-centro">
                                <HasAccess roles={[roles.SUPERADMIN, roles.COORD, roles.ADMINISTRADOR]}>
                                    <Icon type="book" /><span>Asignar centro</span>
                                    <NavLink to="/asignar_centro"></NavLink>
                                </HasAccess>
                            </MenuAntd.Item>
                        }
                        {(["Administrador", "SuperAdmin"].includes(localStorage.getItem("role"))) &&
                            <MenuAntd.Item key="27" id="menu-asignar-unidad">
                                <HasAccess roles={[roles.SUPERADMIN, roles.COORD, roles.ADMINISTRADOR]}>
                                    <Icon type="book" /><span>Asignar unidad Medida</span>
                                    <NavLink to="/asignar_unidad"></NavLink>
                                </HasAccess>
                            </MenuAntd.Item>
                        }
                    </SubMenu>
                }
                <SubMenu key="sub3" title={
                    <span>
                        <Icon type="file-text" />
                        <span style={{ fontSize: "18px", fontWeight: 700 }}>Pedidos</span>
                    </span>
                }>
                    {(localStorage.getItem("role") === "Supervisor de Operaciones Drive" || localStorage.getItem("role") === "Drive" || localStorage.getItem("role") === "Barista" || localStorage.getItem("role") === "Asesor" || localStorage.getItem("role") === "Auditor") &&
                        <MenuAntd.Item key="9" id="menu-generar-pedido">
                            <HasAccess roles={[roles.OPERADOR, roles.SUPERVISOR, roles.BARISTA, roles.ASESOR, roles.AUDITOR]}>
                                <Icon type="wallet" /><span>Generar pedido</span>
                                <NavLink to="/generar_pedido"></NavLink>
                            </HasAccess>
                        </MenuAntd.Item>
                    }
                    <MenuAntd.Item key="10" id="menu-pedidos-realizados">
                        <Icon type="file-done" /><span>Pedidos realizados</span>
                        <NavLink to="/pedidos_realizados"></NavLink>
                    </MenuAntd.Item>
                    <MenuAntd.Item key="24" id="menu-pedidos-realizados-auxiliares">
                        <Icon type="file-done" /><span>Pedidos auxiliares</span>
                        <NavLink to="/pedidos_auxiliares"></NavLink>
                    </MenuAntd.Item>
                </SubMenu>
                {/* {(localStorage.getItem("role") !== "Drive") &&
                    <SubMenu key="sub5" title={
                        <span>
                            <Icon type="code" />
                            <span style={{ fontSize: "18px", fontWeight: 700 }}>Artículos Auxiliares</span>
                        </span>
                    }>
                        {(localStorage.getItem("role") !== "Drive") &&
                            <MenuAntd.Item key="18" id="menu-articulos-auxiliares">
                                <HasAccess roles={[roles.SUPERADMIN, roles.COORD, roles.SUPERVISOR]}>
                                    <Icon type="tags" /><span>Artículos</span>
                                    <NavLink to="/articulos_auxiliares"></NavLink>
                                </HasAccess>
                            </MenuAntd.Item>
                        }
                        {(localStorage.getItem("role") === "Administrador") &&
                            <MenuAntd.Item key="20" id="menu-modelo-pedido-auxiliares">
                                <HasAccess roles={[roles.SUPERADMIN, roles.COORD]}>
                                    <Icon type="tags" /><span>Modelo Pedido</span>
                                    <NavLink to="/modelo_pedido_aux"></NavLink>
                                </HasAccess>
                            </MenuAntd.Item>
                        }
                        {(localStorage.getItem("role") === "Administrador") &&
                            <MenuAntd.Item key="17" id="menu-equivalencia">
                                <HasAccess roles={[roles.SUPERADMIN]}>
                                    <Icon type="ordered-list" /><span>Equivalencia de artículos</span>
                                    <NavLink to="/equivalencia_articulos_aux"></NavLink>
                                </HasAccess>
                            </MenuAntd.Item>
                        }
                        {(localStorage.getItem("role") === "Administrador" || localStorage.getItem("role") === "Coordinador de Operaciones Drive") &&
                            <MenuAntd.Item key="19" id="menu-fuente-demanda-auxiliares">
                                <HasAccess roles={[roles.SUPERADMIN, roles.COORD]}>
                                    <Icon type="book" /><span>Fuente de demanda</span>
                                    <NavLink to="/fuente_demanda_auxiliares"></NavLink>
                                </HasAccess>
                            </MenuAntd.Item>
                        }
                        {(localStorage.getItem("role") === "Administrador") &&
                            <MenuAntd.Item key="21" id="menu-maximo-pedidos">
                                <HasAccess roles={[roles.SUPERADMIN]}>
                                    <Icon type="ordered-list" /><span>Máximo de pedidos</span>
                                    <NavLink to="/maximo_pedidos"></NavLink>
                                </HasAccess>
                            </MenuAntd.Item>
                        }
                    </SubMenu>
                }
                <SubMenu key="sub6" title={
                    <span>
                        <Icon type="border" />
                        <span style={{ fontSize: "18px", fontWeight: 700 }}>Pedidos auxiliares</span>
                    </span>
                }>
                    {(localStorage.getItem("role") === "Supervisor de Operaciones Drive" || localStorage.getItem("role") === "Drive") &&
                        <MenuAntd.Item key="22" id="menu-generar-pedido-auxiliares">
                            <HasAccess roles={[roles.OPERADOR, roles.SUPERVISOR, roles.SUPERADMIN]}>
                                <Icon type="wallet" /><span>Generar pedido</span>
                                <NavLink to="/generar_pedido_auxiliar"></NavLink>
                            </HasAccess>
                        </MenuAntd.Item>
                    }
                    <MenuAntd.Item key="23" id="menu-pedidos-realizados-auxiliares">
                        <Icon type="file-done" /><span>Pedidos realizados</span>
                        <NavLink to="/pedidos_realizados_aux"></NavLink>
                    </MenuAntd.Item>
                </SubMenu>
                {(localStorage.getItem("role") !== "Drive") &&
                    <SubMenu key="sub4" title={
                        <span>
                            <Icon type="file" />
                            <span style={{ fontSize: "18px", fontWeight: 700 }}>Reportes</span>
                        </span>
                    }>
                        <MenuAntd.Item key="11" id="menu-reporte-asertividad">
                            <HasAccess roles={[roles.SUPERADMIN, roles.COORD, roles.SUPERVISOR]}>
                                <Icon type="profile" /><span>Asertividad de pedido</span>
                                <NavLink to="/reporte_asertividad"></NavLink>
                            </HasAccess>
                        </MenuAntd.Item>
                    </SubMenu> 
                }*/}

                <React.Fragment>
                    <div className="btn-logout" onClick={this.props.logout}>
                        <Icon type="logout" />
                        <span className={this.props.collapsed ? "display-none" : ""}> Salir</span>
                    </div>
                </React.Fragment>

            </MenuAntd>
        )
    }
}

export default withRouter(Menu);